module.exports = __webpack_public_path__ + "media/images/ostrovsky-f7e715563a371d9823e1a3d56f9cf138.jpg";